import { render } from "./menu-header.vue?vue&type=template&id=92a38722"
import script from "./menu-header.vue?vue&type=script&lang=js"
export * from "./menu-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__